import { useTheme } from '@mui/material';
const useHistoryStyles = () => {
    const theme = useTheme();
    const headerHeight = '87px';
    const bottomNavigationHeight = '56px';
    const sectionHeaderHeight = '50px';
    return {
        containerStyles: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            p: 0,
            background: theme.palette.background.neutral
        },
        contentContainerStyles: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px',
            paddingBottom: 1,
            px: 2,
            height: `calc(100dvh - ${headerHeight} - ${bottomNavigationHeight} - ${sectionHeaderHeight})`,
            overflowY: 'auto'
        }
    };
};
export default useHistoryStyles;
